<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p53"><span><a href="#/Contents#rp53">HOT CHILI VICHYSSOISE</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Potato soup will never be boring if served Tex-Mex style. This version, prepared with chilies, packs a punch!</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 each: medium leek (white part only), poblano and jalapeño chili</span></p>
<p class="hang"><span>1 pound new red potatoes, unpeeled, halved</span></p>
<p class="hang"><span>6 cloves garlic, peeled</span></p>
<p class="hang"><span>Vegetable cooking spray</span></p>
<p class="hang"><span>1½ teaspoons ground cumin</span></p>
<p class="hang"><span>½ teaspoon each: chili powder, dried oregano leaves</span></p>
<p class="hang"><span>4 cups reduced-sodium fat-free chicken broth, divided</span></p>
<p class="hang"><span>½–¾ cup fat-free half-and-half or fat-free milk</span></p>
<p class="hang"><span>¼ cup chopped cilantro</span></p>
<p class="hang"><span>Salt, to taste</span></p>
<p class="normalt"><span><b>1.</b> Cut leek and chilies into ¾-inch pieces; arrange in single layer on greased foil-lined jelly roll pan; spray with cooking spray and sprinkle with herbs. Roast at 425 degrees until browned and tender, about 40 minutes, removing garlic when tender, about 30 minutes. Process vegetables and 2 cups broth in food processor or blender until smooth. Heat vegetable mixture and remaining broth to boiling in large saucepan; reduce heat to medium. Stir in half-and-half and cook until hot, 3 to 4 minutes. Stir in cilantro; season with salt. Serve warm or chilled.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 113</span></p>
<p class="per1"><span>% calories from fat: 2</span></p>
<p class="per1"><span>Protein (g): 6.6</span></p>
<p class="per1"><span>Carbohydrate (g): 20.9</span></p>
<p class="per1"><span>Fat (g): 0.3</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 169</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0234.vue?2275e483